module.exports = __webpack_public_path__ + "img/icon-service.f8cd25b.svg";